import type { LifeFeatureConfig } from '../../../types/insurances/LifeFeatureConfig';

export const life: LifeFeatureConfig = {
    overview: {
        useCountrySpecificApi: false,
        useBeneficiaryApi: true,
        highlight: {
            showNextPaymentDate: false,
        },
        details: {
            showContractedInsurances: true,
            showVariant: false,
            showPackage: false,
            showContractNumber: true,
            fallbackAssistancePhonesKey: 'HR',
            fallbackAssistanceEmailsKey: 'HR',
        },
        showCoveredRisks: true,
        showUncoveredRisks: true,
        showInsuredPersons: true,
        showBeneficiaries: true,
    },
    history: {
        visible: false,
    },
    risks: {
        visible: false,
    },
    settings: {
        details: {
            showStatus: true,
        },
    },
};
